import { Box } from '@mui/material';
import React from 'react';
import { Alert } from '@mui/material';
import { LICENSE_WORK_TYPES_URL } from '../../constants/urls';
import { FORM8_LICENSES, getInitialForm8Licenses } from '../../constants/lkCadastr/cadastrForm8';
import { flexGap2, fullWidth } from '../../constants/lkCadastr/cadastrStorage';
import useCadastreTabs from '../../hooks/useCadastreTabs';
import AddButton from '../Buttons/AddButton';
import DeleteButton from '../Buttons/DeleteButton';
import CustomCheckbox from '../CustomCheckbox';
import CustomDatePicker from '../CustomDatePicker';
import CustomAutocomplete from '../Inputs/CustomAutocomplete';
import NavTabs from '../Tabs';
import { Text } from '../Text';
import { AsyncAutocomplete } from '../AutoCompletes/AsyncAutocomplete';
import { getReferencesRequest } from '../../api/referenceApi';

export default function CadastreLicensesContainer({
  placingObject,
  changeObject,
  isDemo,
  form5Licenses,
  changeLicenseUnneeded,
  is_license_unneeded,
  deleteForm8License,
  openDeleteModal,
}) {
  const licenses = placingObject[FORM8_LICENSES];

  const { tab, setTab, tabs } = useCadastreTabs({ items: licenses, tabName: 'Лицензия' });
  const filteredLicenses = form5Licenses.filter(license => license.technology_object);

  return (
    <Box sx={flexGap2}>
      <Alert severity="info">
        Не требуется лицензия на деятельность по сбору, транспортированию, обработке, утилизации, обезвреживанию, размещению отходов V класса опасности
      </Alert>
      <CustomCheckbox
        disabled={isDemo}
        label="Лицензия не требуется"
        value={is_license_unneeded}
        onChange={changeLicenseUnneeded}
      />
      {!is_license_unneeded && (
        <>
          {(!isDemo) && (
           <AddButton
             variant="outlined"
             onClick={() => changeObject(
               FORM8_LICENSES,
               [...licenses, getInitialForm8Licenses()],
             )}
           >
             Добавить лицензию
           </AddButton>
          )}
          <NavTabs tabsComponents={tabs} setTab={setTab} tab={tab} />
          {licenses.map((license, licenseIndex) => {
            if (tab !== license.randId) return null;

            const changeLicense = (field, value) => {
              changeObject(`${FORM8_LICENSES}.${licenseIndex}.${field}`, value);
            };

            const mainLicense = license?.license;

            const isLicenseDisable = !!mainLicense.technology_object_id;
            const isLicenseForm7Disable = !!(isDemo || isLicenseDisable);
            const isLicenseForm8Disable = !!(isDemo || mainLicense.is_forever);

            const onDeleteLicense = async () => {
              if (mainLicense?.id) {
                const deletedLicense = await deleteForm8License({ reportLicenseId: mainLicense.id });

                if (!deletedLicense) return;
              }

              const cloneArray = licenses.slice();
              cloneArray.splice(licenseIndex, 1);

              changeObject(
                FORM8_LICENSES,
                cloneArray,
                'delete',
              );
            };

            return (
              <Box key={license.randId} sx={flexGap2}>
                <Box display="flex" alignItems="center" gap={3}>
                  <Text>
                    Лицензия №
                    {licenseIndex + 1}
                  </Text>
                  {!isDemo && licenses.length > 1 && (
                    <DeleteButton onClick={() => openDeleteModal(onDeleteLicense, licenseIndex, 'Лицензию')}>
                      Удалить лицензию
                    </DeleteButton>
                  )}
                </Box>
                <Box sx={flexGap2}>
                  <Box>
                    <Text className="mute">Номер</Text>
                    <CustomAutocomplete
                      validImmediately
                      debounceTime={0}
                      disabled={isDemo || isLicenseDisable}
                      value={mainLicense}
                      fields={{ label: 'license_number' }}
                      onChange={(e, value) => {
                        if (mainLicense.id) value.id = mainLicense.id;
                        if (mainLicense.technology_object_id) value.technology_object_id = mainLicense.technology_object_id;
                        return changeLicense('license', value);
                      }}
                      options={filteredLicenses}
                    />
                  </Box>
                  <Box>
                    <Text className="mute">Дата</Text>
                    <CustomDatePicker
                      disabled={isDemo || isLicenseDisable}
                      validImmediately
                      value={mainLicense?.license_issue_date || null}
                      onChange={(e, value) => changeLicense('license.license_issue_date', value)}
                      sx={fullWidth}
                    />
                  </Box>
                  <Box display="flex" alignItems="center" gap={3}>
                    <Box>
                      <Text className="mute">Срок действия</Text>
                      <CustomDatePicker
                        disabled={mainLicense?.technology_object_id ? isLicenseForm7Disable : isLicenseForm8Disable}
                        validImmediately={!mainLicense?.is_forever}
                        value={mainLicense?.is_forever ? null : mainLicense?.license_expiration || null}
                        onChange={(e, value) => changeLicense('license.license_expiration', value)}
                      />
                    </Box>
                    <CustomCheckbox
                      disabled={isDemo || isLicenseDisable}
                      value={mainLicense?.is_forever}
                      label="Бессрочно"
                      onChange={(e, value) => changeLicense('license.is_forever', value)}
                    />
                  </Box>
                  <Box>
                    <Text className="mute">Виды работ</Text>
                    <AsyncAutocomplete
                      multiple
                      disabled={isDemo || isLicenseDisable}
                      validImmediately
                      sx={fullWidth}
                      value={mainLicense?.license_work_types_ids || []}
                      request={(params) => getReferencesRequest({
                        url: LICENSE_WORK_TYPES_URL,
                        params,
                      })}
                      onChange={(e, value) => changeLicense('license.license_work_types_ids', value)}
                    />
                  </Box>
                </Box>
              </Box>
            );
          })}
        </>
        )
      }
    </Box>
  );
}
